import { Guid, Nillable } from '@web/utils';
import { AdminOrderBuyer } from './admin-order-buyer';
import { OrderStatus, ShippingMethodDictionary } from '@web/shared/module/shop';
import { AdminPaymentMethod } from './admin-payment-method';
import { AdminOrderShipmentTracking } from './admin-order-shipment-tracking';
import { AdminOrderProduct } from './admin-order-product';
import { AdminOrderInvoice } from './admin-order-invoice';
import { DictionaryCountry } from '@web/shared/module/dictionary';
import { RefundSummary } from '@web/shared/module/shop';

export class AdminOrderCollectionItem {
  public constructor(
    private readonly data: {
      canBeCancelled: boolean;
      canBeMarkAsPaid: boolean;
      canBeViewed: boolean;
      canBeRefunded: boolean;
      hasError: boolean;
      errorMessage?: Nillable<string>;
      comment?: Nillable<string>;
      id: Guid;
      number: string;
      status: OrderStatus;
      totalPrice: number;
      createdAt: Date;
      shippingMethods: ShippingMethodDictionary[];
      paymentMethod: AdminPaymentMethod;
      buyer: AdminOrderBuyer;
      products: AdminOrderProduct[];
      invoices: AdminOrderInvoice[];
      shippingCountries: DictionaryCountry[];
      shipments: AdminOrderShipmentTracking[];
      variants: string[];
      refundSummary?: Nillable<RefundSummary>;
      skinType?: Nillable<string>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get canBeCancelled(): boolean {
    return this.data.canBeCancelled;
  }

  public get canBeMarkAsPaid(): boolean {
    return this.data.canBeMarkAsPaid;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeRefunded(): boolean {
    return this.data.canBeRefunded;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get number(): string {
    return this.data.number;
  }

  public get status(): OrderStatus {
    return this.data.status;
  }
  public get totalPrice(): number {
    return this.data.totalPrice;
  }

  public get refundSummary(): Nillable<RefundSummary> {
    return this.data.refundSummary;
  }

  public get buyer(): AdminOrderBuyer {
    return this.data.buyer;
  }

  public get shippingCountries(): DictionaryCountry[] {
    return this.data.shippingCountries;
  }

  public get products(): AdminOrderProduct[] {
    return this.data.products;
  }

  public get invoices(): AdminOrderInvoice[] {
    return this.data.invoices;
  }

  public get shippingMethods(): ShippingMethodDictionary[] {
    return this.data.shippingMethods;
  }

  public get paymentMethod(): AdminPaymentMethod {
    return this.data.paymentMethod;
  }

  public get shipments(): AdminOrderShipmentTracking[] {
    return this.data.shipments;
  }

  public get hasError(): boolean {
    return this.data.hasError;
  }

  public get errorMessage(): Nillable<string> {
    return this.data.errorMessage;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get variants(): string[] {
    return this.data.variants;
  }

  public get skinType(): Nillable<string> {
    return this.data.skinType;
  }
}
